import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMovToGifConverterConfig } from '@/data/landingConfig/landingMovToGifConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MovToGifConverter } from './schemaObject';

interface Props {}
const MovToGifConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MovToGifConverter} />
			<VideoLandingTemplate
				data={landingMovToGifConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default MovToGifConverter;
